import React from "react";
import { store } from "../../redux/store";
import axios from 'axios';

import { connect } from "react-redux";

import history from "../../auth/history";
import Avatar from 'react-avatar';
import { selectedBeneList, setBeneMoneyTransfer } from "../../redux/misc-data/misc-data.action";
import BankLogo from "../../assests/images/bank-logo.png";
import { selectedSender } from './../../redux/misc-data/misc-data.action';
import { Link } from "react-router-dom";
const httpClient = axios.create();

class AddedBeneficiary extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			errorMessage: '',
			progress:''
		}
	}


	componentDidMount() { }
	componentWillUnmount() {
	}





	moneyTransfer = () => {



		var benefc = {
			name: this.props.name,
			bankName: this.props.bankName,
			accountNumber: this.props.accNo,
			ifscCode: this.props.ifsc,
			beneId: this.props.beneId,
			beneMobile: this.props.beneMobile
		}

		store.dispatch(setBeneMoneyTransfer(benefc));

        var moneytransfer=document.getElementById('moneytransfer');
		moneytransfer.click();
	}

	acivateOnOff = (event) => {
		event.preventDefault();
		var url = '';
		this.setState({
			progress:'started'
		})
		if (this.props.active == true) {
			url = '/api/v1/dmt/beneficiary/deactivate/' + this.props.selectSender.customer.id + '/' + this.props.id
		} else if (this.props.active == false) {
			url = '/api/v1/dmt/beneficiary/activate/' + this.props.selectSender.customer.id + '/' + this.props.id
		}

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			 'role': this.props.clientRole
		}


		httpClient.post(url, '',
			{ headers }
		).then((response) => {

			this.setState({
				progress:'completed'
			})
			if (response.data == true) {
				console.log('active toggle success response...' + JSON.stringify(response.data));


				var allsenderuRL = '/api/v1/dmt/customer/details/' +
					this.props.selectSender.customer.mobile;
				const headers = {
					'Authorization': 'Bearer ' + this.props.token,
					'client-id': this.props.agentInfo.id,
					'role':this.props.clientRole
				}

				httpClient.get(allsenderuRL, { headers }
				).then((response) => {
					console.log('selected sender response' + JSON.stringify(response.data));
					console.log(response.data.response.msg);
					if (response.data.response.msg == 'SUCCESS') {

						store.dispatch(selectedSender(response.data));
						store.dispatch(selectedBeneList(response.data.customer.beneficiaries));

					} else {
						this.errorMessageCall(response.data.response.displayMsg)

					}
				}).catch(error => {
					console.log('error in fetch sender details...' + error);
					this.errorMessageCall(error.message);
				});


			} else {
				console.log('active toggle failed response...' + JSON.stringify(response.data));
			}




		}).catch(error => {
			this.setState({
				progress:'completed'
			})
			console.log('error in active toggle...' + error);
			this.errorMessageCall(error.message);

		});



	}

	errorMessageCall = (error) => {
		this.setState({
			errorMessage: error
		})
	}


	render() {
		console.log(JSON.stringify(this.props.bankLogoListTxt))
		// var verifiedAccount=false;
		// verifiedAccount=this.props.verifiedAccount;
		return (

			<div class="beneficiary">


				<Link to='/money-transfer'>
					<button id='moneytransfer' hidden={true}></button>
				</Link>
				{this.state.errorMessage != '' &&
					<div class='valid-error'>
						{this.state.errorMessage}
					</div>}
				<div class="row">
					<div class="col-12 col-md-4 col-lg-4">
						<div class="benetxt">



							{(this.props.bankName != null &&
								this.props.bankLogoListTxt.includes(this.props.bankName.split(' ').join("-") + ".PNG")) ?
								<img src={'/bank_images/' + this.props.bankName.toLowerCase().split(' ').join("-") + ".png"} alt="bank" /> :
								<img src={BankLogo} alt="bank" />
							}

							{this.props.verifiedAccount == true &&
								<h4 class="verify">{this.props.name}</h4>
							}
							{this.props.verifiedAccount == false &&
								<h4>{this.props.name}</h4>
							}
							<p>{this.props.bankName}</p>
						</div>
					</div>
					<div class="col-6 col-md-2 col-lg-3">
						<div class="benetxt">
							<h5>Account Number</h5>
							<p>{this.props.accNo}</p>
						</div>
					</div>
					<div class="col-6 col-md-2 col-lg-2">
						<div class="benetxt srtxt">
							<h5>IFSC code</h5>
							<p>{this.props.ifsc}</p>
							{this.props.status}
						</div>
					</div>



					{/* <div class="col-12 col-md-4 col-lg-3">
												<div class="acnbtn">
													<button type="button" class={this.props.active==true?"grbtn":"lbbtn"} onClick={this.acivateOnOff}>{this.props.active==true?'Inactive':'Active'}</button>
													{this.props.active==true?
													<button type="button" class="dbbtn" onClick={this.moneyTransfer}>Money Transfer</button>
													:<button type="butto" class="dbbtn btn" disabled>Money Transfer</button>
													}
												</div>
											</div> */}

					<div class="col-12 col-md-4 col-lg-3">
						<div class="acnbtn">
							<div class="form-check form-switch">
								<input class="form-check-input" type="checkbox"
									role="switch" id="flexSwitchCheckChecked" checked={this.props.active == true ? true : false}
									onClick={this.acivateOnOff} readOnly={this.state.progress=='started'?true:false} />
								<label class="form-check-label" for="flexSwitchCheckChecked">{this.props.active == true ? "Active" : "Inactive"}
								</label>


							</div>
							{this.props.active == true ?
								<button type="button" class="dbbtn" onClick={this.moneyTransfer}>Money Transfer</button>
								: <button type="butto" class="dbbtn btn" disabled>Money Transfer</button>
							}
						</div>
					</div>
				</div>
			</div>

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, selectSender, token, clientRole,agentInfo, bankLogoListTxt } }
) => ({
	errorMessage, loginErrorMessage, phone, selectSender, token,clientRole,agentInfo, bankLogoListTxt
});

export default connect(mapStateToProps, null)(AddedBeneficiary);
